export const productHighlights = [
  { label: 'LFP-cellen', value: 'Veiligste lithiumtechniek, geen kobalt' },
  { label: 'Levensduur', value: '6.000 laadcycli, ruim 15 jaar' },
  { label: 'Beschermingsklasse', value: 'IP65 — ook in garage of schuur' },
  { label: 'Temperatuur', value: 'Werkt van -10 °C tot 50 °C' },
  { label: 'Geluid', value: 'Onder 25 dB, stiller dan een koelkast' },
  { label: 'Noodstroom', value: 'Schakelt in 20 ms om bij stroomuitval' },
]

export const comparisonRows: { label: string; values: [string, string, string] }[] = [
  { label: 'Opslagcapaciteit', values: ['5,1 kWh', '10,2 kWh', '15,3 kWh'] },
  { label: 'Bruikbare capaciteit', values: ['4,6 kWh', '9,2 kWh', '13,8 kWh'] },
  { label: 'Laad- en ontlaadvermogen', values: ['3 kW', '5 kW', '6 kW'] },
  { label: 'Modules', values: ['1', '2', '3'] },
  { label: 'Afmetingen (b × h × d)', values: ['60 × 52 × 18 cm', '60 × 92 × 18 cm', '60 × 132 × 18 cm'] },
  { label: 'Gewicht', values: ['52 kg', '98 kg', '144 kg'] },
  { label: 'Noodstroom', values: ['Optioneel', 'Inbegrepen', 'Inbegrepen'] },
  { label: 'Uitbreidbaar tot', values: ['15,3 kWh', '15,3 kWh', '—'] },
  { label: 'Geschikt voor', values: ['Tot 10 panelen', '10–18 panelen', '18+ panelen, EV, warmtepomp'] },
]

export const included = [
  { title: 'Adviesgesprek aan huis', text: 'Inclusief inspectie van meterkast en montageplek.' },
  { title: 'Installatie in één dag', text: 'Door eigen, gecertificeerde monteurs. Netjes afgewerkt.' },
  { title: 'Koppeling met je omvormer', text: 'Hybride omvormer of AC-koppeling, wat het beste past.' },
  { title: 'App en slim laden', text: 'Automatisch sturen op zon, weer en uurprijzen.' },
  { title: 'Aanmelding netbeheerder', text: 'Wij regelen de registratie op energieleveren.nl.' },
  { title: '10 jaar garantie', text: 'Op batterij en omvormer, 5 jaar op de installatie.' },
]

export const aboutStats = [
  { value: '4.800+', label: 'thuisbatterijen geïnstalleerd' },
  { value: '42', label: 'eigen monteurs en adviseurs' },
  { value: '2016', label: 'opgericht in Veenendaal' },
  { value: '4,9', label: 'gemiddelde klantbeoordeling' },
]

export const values = [
  {
    title: 'Eerlijk advies, ook als het “nee” is',
    text: 'Levert een batterij in jouw situatie weinig op? Dan zeggen we dat. Onze adviseurs krijgen geen bonus per verkochte kWh.',
  },
  {
    title: 'Eigen mensen, geen onderaannemers',
    text: 'Iedere monteur is bij ons in dienst en opgeleid in onze eigen trainingsruimte. Zo weet je wie er over de vloer komt.',
  },
  {
    title: 'We blijven na de installatie',
    text: 'We monitoren je systeem op afstand en bellen zelf als er iets afwijkt. Service is bij ons geen afdeling, maar een belofte.',
  },
]

export const certifications = ['InstallQ', 'Techniek Nederland', 'Stichting Zonnekeur', 'NEN 1010', 'VCA*']

export const contactChannels = [
  { title: 'Bel ons', value: '085 – 000 00 00', href: 'tel:0850000000', note: 'Ma–vr 8:00–20:00 · za 9:00–16:00' },
  { title: 'WhatsApp', value: '06 00 00 00 00', href: 'https://wa.me/31600000000', note: 'Gemiddeld binnen 15 minuten antwoord' },
  { title: 'E-mail', value: 'advies@stroomkluis.nl', href: 'mailto:advies@stroomkluis.nl', note: 'Binnen één werkdag reactie' },
]

export const openingHours = [
  { day: 'Maandag – vrijdag', hours: '09:00 – 17:30' },
  { day: 'Donderdag', hours: '09:00 – 21:00' },
  { day: 'Zaterdag', hours: '10:00 – 16:00' },
  { day: 'Zondag', hours: 'Gesloten' },
]
